import { Typography } from '@mui/material';
import { isEmptyArray, withDefault } from '@weft/utils';
import { useDropdownChangeHandler } from 'apps/app/src/components/design/dropdowns/Dropdown';
import { withSuspenseBoundary } from 'apps/app/src/components/utility/SuspenseBoundary';
import { useStripeCustomers } from 'apps/app/src/hooks/requests/use-stripe-customers';
import React from 'react';
import { Spinner } from '../../../components/design/Spinner';
import { StripeCustomersDropdown } from './StripeCustomerDropdown';

const StripeCustomersForm: React.FC = () => {
  const { data, isError, isLoading } = useStripeCustomers();
  const handleSelectChange = useDropdownChangeHandler();
  const customers = withDefault(data?.customers, []);

  if (isLoading) {
    return (
      <Spinner/>
    );
  }

  if (isEmptyArray(customers) || isError) {
    return (
      <Typography>No customers to show</Typography>
    );
  }

  return (
    <StripeCustomersDropdown
      customers={customers}
      menuItemClickHandler={handleSelectChange('stripeCustomerId')}
    />
  );
};

const StripeCustomersFormWithSuspenseBoundary = withSuspenseBoundary(StripeCustomersForm);
export { StripeCustomersFormWithSuspenseBoundary as StripeCustomersForm };